export default "__VITE_ASSET__5bef9589__"